export default __webpack_public_path__ + "fd040fb5f4e7a515bb3cc0a671416f77.svg";